/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Review_P3Inputs */

const en_wc_tut_review_p3 = /** @type {(inputs: Wc_Tut_Review_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelling and grammar are checked as you type, offline. Press F7 to step through suggestions.`)
};

/**
* | output |
* | --- |
* | "Spelling and grammar are checked as you type, offline. Press F7 to step through suggestions." |
*
* @param {Wc_Tut_Review_P3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_review_p3 = /** @type {((inputs?: Wc_Tut_Review_P3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Review_P3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_review_p3(inputs)
});
export { wc_tut_review_p3 as "wc.tut.review.p3" }